module.exports = __webpack_public_path__ + "static/media/onboarding-card.a5224a5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboarding-card.svg
// module id = 361
// module chunks = 0